import { render, staticRenderFns } from "./AssessmentGlobalSingleTaskModalAuxModals.vue?vue&type=template&id=1569e534&"
import script from "./AssessmentGlobalSingleTaskModalAuxModals.vue?vue&type=script&lang=js&"
export * from "./AssessmentGlobalSingleTaskModalAuxModals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports